import React from 'react'
import { DealDetail, ServicingType } from 'api'
import { ActionsButtonProps } from 'view/components/datagrid'
import { MidTradeEventActionsButton } from './MidTradeEventActionsButton'
import { MidTradeEventLockRenderer } from './MidTradeEventLockRenderer'

export const MidTradeEventActionsCell: React.FC<ActionsButtonProps<DealDetail>> = ({ context, ...rest }) => {
  const { items, isGroupRow } = rest
  const dealDetail = items[0]

  if (!dealDetail) {
    return null
  }

  const renderLock = () => {
    if (
      isGroupRow ||
      dealDetail.isServicingInitiator ||
      (dealDetail.deal.servicingDetails?.servicingType.servicingType !== ServicingType.CLOSE_OPEN &&
        dealDetail.deal.servicingDetails?.servicingType.servicingType !== ServicingType.RERATE)
    ) {
      return null
    }

    return <MidTradeEventLockRenderer dealDetail={dealDetail} />
  }

  return (
    <>
      <MidTradeEventActionsButton {...rest} />
      {renderLock()}
    </>
  )
}
